import {
  DateTimePickerProps as MantineDateTimePickerProps,
  DateTimePicker as MantineDateTimePicker,
} from '@mantine/dates';

export type DateTimePickerProps = MantineDateTimePickerProps;

export const DateTimePicker = MantineDateTimePicker;

DateTimePicker.displayName = 'DateTimePicker';
